import React from 'react';
import ReactStars from "react-rating-stars-component";
import { IoIosAddCircle } from "react-icons/io";
import { FiHeart, FiEye } from "react-icons/fi";
import { MdOutlineCompareArrows } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { Badge, Tag, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { addToCart } from '../store/reducers/cartSlice';

const ProductCard = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    id,
    product_title,
    image1,
    image2,
    price,
    star_number,
    available = true,
    description = "",
    grid
  } = props;

  const handleAddToCart = () => {
    dispatch(addToCart({ id, product_title, image1, price, quantity: 1 }));
  };

  const handleViewDetails = () => {
    navigate(`/product/${id}`);
  };

  return (
    <div className={`${location.pathname === "/magasin" ? `gr-${grid}` : 'col-12 col-sm-6 col-md-4 col-lg-3'} mb-4`}>
      <Badge.Ribbon
        text={available ? "Promo" : "Rupture"}
        color={available ? "red" : "volcano"}
      >
        <div className='product-card position-relative h-100 d-flex flex-column'>

          {/* Wishlist icon */}
          <div className="wishlist-icon position-absolute">
            <Tooltip title="Ajouter aux favoris">
              <FiHeart className='fs-5' />
            </Tooltip>
          </div>

          {/* Image */}
          <div
            className='product-image w-100 position-relative'
            onClick={handleViewDetails}
            style={{ height: '200px', overflow: 'hidden', cursor: 'pointer' }}
            >
            <img
                src={image1}
                className='primary-image img-fluid w-100 h-100 position-absolute top-0 start-0'
                style={{ objectFit: 'cover' }}
                alt='image produit'
            />
            {image2 && (
                <img
                src={image2}
                className='secondary-image img-fluid w-100 h-100 position-absolute top-0 start-0'
                style={{ objectFit: 'cover' }}
                alt='image secondaire'
                />
            )}
          </div>


          {/* Détails produit */}
          <div className='product-details p-2 flex-grow-1 d-flex flex-column justify-content-between'>
            <div>
              <Tag color="blue">Catégorie</Tag>
              <h6 className='brand text-muted'>Grenier des Plateaux</h6>
              <h5 className='product-title'>{product_title}</h5>
              <ReactStars count={5} size={20} value={star_number} edit={false} activeColor="#ffd700" />
              {grid === 12 && (
                <p className="description text-muted">
                  {description.length > 80 ? description.substring(0, 80) + "..." : description}
                </p>
              )}
            </div>
            <div>
              <p className='price fw-bold'>{price} FCFA / Kg</p>
              <button className='button w-100 mt-2' 
                      disabled={!available}
                      style={{ border: 'none', outline: 'none', boxShadow: 'none' }} 
                      onClick={handleAddToCart}>
                {available ? "Ajouter au panier" : "Indisponible"}
              </button>
            </div>
          </div>

          {/* Action bar */}
          <div className="action-bar position-absolute d-flex flex-column gap-2">
            <Tooltip title="Comparer"><MdOutlineCompareArrows className='fs-5' /></Tooltip>
            <Tooltip title="Voir"><FiEye className='fs-5' onClick={handleViewDetails} /></Tooltip>
            <Tooltip title="Ajouter au panier"><IoIosAddCircle className='fs-5' onClick={handleAddToCart} /></Tooltip>
          </div>

        </div>
      </Badge.Ribbon>
    </div>
  );
};

export default ProductCard;
